module.exports = __webpack_public_path__ + "static/media/Padraic.8ce55e8b.png";